export default __webpack_public_path__ + "static/media/sip-calendar.5404a092.svg";